import styled from 'styled-components';

export const Container = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgb(0, 0, 0, 0.2);
    z-index: 1000;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Content = styled.div`
    background-color: ${(props) => props.theme.colors.white};
    padding: 30px;
    border-radius: 4px;
    /* max-width: 600px; */

    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};
`;

export const Title = styled.h2`
  font-size: 24px;
  color: ${(props) => props.theme.colors.gray.gray_800};
  font-weight: 500;
`;

export const Controls = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
  align-items: center;
`;

export const TypeSelector = styled.div`
  display: flex;
  gap: 15px;
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  font-size: 14px;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;

  background-color: ${(props) => props.theme.colors.primary};
  color:  ${(props) => props.theme.colors.white};
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 15px;
  cursor: pointer;
  font-size: 14px;
  
  &:hover {
    background-color: ${(props) => props.theme.colors.red.red_800};
  }
  
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

export const TagsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  width: 100%;

  overflow-y: auto;
  max-height: 250px;
`;

export const TagCard = styled.div`
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TagPreview = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  
  svg {
    max-width: 100%;
    height: auto;
  }
`;

export const DownloadButton = styled.button`
  background-color: ${(props) => props.theme.colors.primary};
  color:  ${(props) => props.theme.colors.white};
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  align-self: flex-end;
  
  &:hover {
    background-color: ${(props) => props.theme.colors.red.red_800};
  }
  
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  width: 100%;
  color: #999;
  font-size: 16px;
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
`;

export const PrintQrcodeSmall = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  border: 1px dashed ${(props) => props.theme.colors.gray.gray_50};
`;

export const LeftSection = styled.div`
  display: flex;
`;

export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LabelName = styled.p<{isLarge:boolean}>`
  font-size: ${(props) => props.isLarge ? '16px' : '12px'};
  max-width: 150px;
  word-wrap: break-word;
`;

export const CardTag = styled.div<{isLarge: boolean}>`
  display: flex;
  align-items: center;
  gap: ${(props) => props.isLarge ? '20px' : '50px'};
`;

export const Label = styled.label`
  color: ${(props) => props.theme.colors.gray.gray_800};
  font-size: 14px;
`;

export const SelectTag = styled.select`
  background-color: transparent;
  border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
  padding: 10px;
  width: 100%;
`;